import {required} from "vuelidate/lib/validators";  
const menus = {
    data() { 
      return {   
        menusData: {  
          Title: "", 
          Link: "",   
          Dataorder: "1", 
          Isprivate: false, 
          Topid: null,
          Websiteid: null,
          Auth:null
          }, 
  
          FormDataType:{
            Title:{FieldName:"Title",Field:"input",FieldTitle:this.$t('menus.AddEdit.Title')},  
            Link:{FieldName:"Link",Field:"input",FieldTitle:this.$t('menus.AddEdit.Link')},  
            Dataorder:{FieldName:"Categoryid",Field:"input",FieldTitle:this.$t('menus.AddEdit.Dataorder'),FieldType:'number'},
            Isprivate:{FieldName:"Isprivate",Field:"input",FieldTitle:this.$t('menus.AddEdit.Isprivate')},   
            Auth:{FieldName:"Auth",Field:"checkbox",FieldTitle:this.$t('menus.AddEdit.Auth')},   
          } 
      }
    },  
    validations:{ 
      FormData: {  
        Title: {required},   
        Link: {},  
        Dataorder:{},    
        Isprivate: {},  
        Auth: {},    

      }
 
  },
  created(){ 
  }
}
export default menus